export default function parseCities(cities) {
  //convert array to values react select can read
  let returnValue = [];
  for (var i = 0; i < cities.length; i++) {
    returnValue.push({
      value: cities[i].id,
      label: cities[i].name,
    });
  }
  return returnValue;
}
